export const PER_PAGE = 20;
export const ACCOUNT_TYPE_PERSON = 'person';
export const ACCOUNT_TYPE_COMPANY = 'company';